import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './PostCard.scss'
import { InlineShell } from '../Shells'
import truncate from 'lodash/truncate'

function htmlDecode(input) {
	var doc = new DOMParser().parseFromString(input, 'text/html')
	return doc.documentElement.textContent
}

const prepareExcerpt = ({ excerpt, length }) => {
	return truncate(htmlDecode(excerpt), {
		length,
		separator: /,? +/,
		omission: '...'
	})
}

const PostCard = ({ shell, url, category, title, excerpt, author, image }) => {
	if (shell) {
		return (
			<div styleName="element">
				<div styleName="body">
					<div styleName="main-info">
						<div styleName="category">
							<InlineShell width={120} />
						</div>
						<div styleName="title">
							<InlineShell width={300} />
						</div>
						<InlineShell width={100} />
					</div>
					<div styleName="meta-info">
						<div styleName="details">
							<InlineShell />
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<a href={url} styleName="element" target="_blank" rel="noopener">
			<div styleName="body">
				<div styleName="main-info">
					<div styleName="category">
						{category}
					</div>
					<div
						styleName="title"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
					{image
						? <img
								src={image.source_url}
								styleName="image"
								role="presentation"
							/>
						: ''}
					{excerpt
						? <div styleName="desc">
								{prepareExcerpt({ excerpt, length: 190 })}
							</div>
						: ''}
				</div>
				<div styleName="meta-info">
					<div styleName="details">
						<span>
							by {author.name}
						</span>
						<img
							styleName="avatar"
							src={author.avatar}
							alt="Avatar"
						/>
					</div>
				</div>
			</div>
		</a>
	)
}

export default CSSModules(PostCard, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/PostCard/PostCard.js